// Data Sources
export const REPORT_DATASOURCE_DETECT_REQUEST = 'REPORT_DATASOURCE_DETECT_REQUEST';
export const REPORT_DATASOURCE_DETECT_SUCCESS = 'REPORT_DATASOURCE_DETECT_SUCCESS';
export const REPORT_DATASOURCE_DETECT_FAIL    = 'REPORT_DATASOURCE_DETECT_FAIL';

export const REPORT_DATASOURCE_SCHEMAS_REQUEST = 'REPORT_DATASOURCE_SCHEMAS_REQUEST';
export const REPORT_DATASOURCE_SCHEMAS_SUCCESS = 'REPORT_DATASOURCE_SCHEMAS_SUCCESS';
export const REPORT_DATASOURCE_SCHEMAS_FAIL    = 'REPORT_DATASOURCE_SCHEMAS_FAIL';

export const REPORT_DATASOURCE_CREATE_REQUEST = 'REPORT_DATASOURCE_CREATE_REQUEST';
export const REPORT_DATASOURCE_CREATE_SUCCESS = 'REPORT_DATASOURCE_CREATE_SUCCESS';
export const REPORT_DATASOURCE_CREATE_FAIL    = 'REPORT_DATASOURCE_CREATE_FAIL';

export const REPORT_DATASOURCE_UPDATE_REQUEST = 'REPORT_DATASOURCE_UPDATE_REQUEST';
export const REPORT_DATASOURCE_UPDATE_SUCCESS = 'REPORT_DATASOURCE_UPDATE_SUCCESS';
export const REPORT_DATASOURCE_UPDATE_FAIL    = 'REPORT_DATASOURCE_UPDATE_FAIL';

export const REPORT_DATASOURCE_DELETE_REQUEST = 'REPORT_DATASOURCE_DELETE_REQUEST';
export const REPORT_DATASOURCE_DELETE_SUCCESS = 'REPORT_DATASOURCE_DELETE_SUCCESS';
export const REPORT_DATASOURCE_DELETE_FAIL    = 'REPORT_DATASOURCE_DELETE_FAIL';

// Pg function browser
export const REPORT_PG_FUNCTIONS_REQUEST = 'REPORT_PG_FUNCTIONS_REQUEST';
export const REPORT_PG_FUNCTIONS_SUCCESS = 'REPORT_PG_FUNCTIONS_SUCCESS';
export const REPORT_PG_FUNCTIONS_FAIL    = 'REPORT_PG_FUNCTIONS_FAIL';

export const REPORT_DATASOURCE_LIST_REQUEST = 'REPORT_DATASOURCE_LIST_REQUEST';
export const REPORT_DATASOURCE_LIST_SUCCESS = 'REPORT_DATASOURCE_LIST_SUCCESS';
export const REPORT_DATASOURCE_LIST_FAIL    = 'REPORT_DATASOURCE_LIST_FAIL';

// Functions
export const REPORT_FUNCTION_LIST_REQUEST   = 'REPORT_FUNCTION_LIST_REQUEST';
export const REPORT_FUNCTION_LIST_SUCCESS   = 'REPORT_FUNCTION_LIST_SUCCESS';
export const REPORT_FUNCTION_LIST_FAIL      = 'REPORT_FUNCTION_LIST_FAIL';

export const REPORT_FUNCTION_DESCRIBE_REQUEST = 'REPORT_FUNCTION_DESCRIBE_REQUEST';
export const REPORT_FUNCTION_DESCRIBE_SUCCESS = 'REPORT_FUNCTION_DESCRIBE_SUCCESS';
export const REPORT_FUNCTION_DESCRIBE_FAIL    = 'REPORT_FUNCTION_DESCRIBE_FAIL';
export const REPORT_FUNCTION_DESCRIBE_RESET   = 'REPORT_FUNCTION_DESCRIBE_RESET';

export const REPORT_FUNCTION_TEMPLATES_REQUEST = 'REPORT_FUNCTION_TEMPLATES_REQUEST';
export const REPORT_FUNCTION_TEMPLATES_SUCCESS = 'REPORT_FUNCTION_TEMPLATES_SUCCESS';
export const REPORT_FUNCTION_TEMPLATES_FAIL    = 'REPORT_FUNCTION_TEMPLATES_FAIL';

export const REPORT_FUNCTION_DEPLOY_REQUEST = 'REPORT_FUNCTION_DEPLOY_REQUEST';
export const REPORT_FUNCTION_DEPLOY_SUCCESS = 'REPORT_FUNCTION_DEPLOY_SUCCESS';
export const REPORT_FUNCTION_DEPLOY_FAIL    = 'REPORT_FUNCTION_DEPLOY_FAIL';

export const REPORT_FUNCTION_EXECUTE_REQUEST = 'REPORT_FUNCTION_EXECUTE_REQUEST';
export const REPORT_FUNCTION_EXECUTE_SUCCESS = 'REPORT_FUNCTION_EXECUTE_SUCCESS';
export const REPORT_FUNCTION_EXECUTE_FAIL    = 'REPORT_FUNCTION_EXECUTE_FAIL';

// Raw query (SQL Lab test runner)
export const REPORT_DATASOURCE_QUERY_REQUEST = 'REPORT_DATASOURCE_QUERY_REQUEST';
export const REPORT_DATASOURCE_QUERY_SUCCESS = 'REPORT_DATASOURCE_QUERY_SUCCESS';
export const REPORT_DATASOURCE_QUERY_FAIL    = 'REPORT_DATASOURCE_QUERY_FAIL';
export const REPORT_DATASOURCE_QUERY_RESET   = 'REPORT_DATASOURCE_QUERY_RESET';

// Dashboards
export const REPORT_DASHBOARD_LIST_REQUEST   = 'REPORT_DASHBOARD_LIST_REQUEST';
export const REPORT_DASHBOARD_LIST_SUCCESS   = 'REPORT_DASHBOARD_LIST_SUCCESS';
export const REPORT_DASHBOARD_LIST_FAIL      = 'REPORT_DASHBOARD_LIST_FAIL';

export const REPORT_DASHBOARD_DETAILS_REQUEST = 'REPORT_DASHBOARD_DETAILS_REQUEST';
export const REPORT_DASHBOARD_DETAILS_SUCCESS = 'REPORT_DASHBOARD_DETAILS_SUCCESS';
export const REPORT_DASHBOARD_DETAILS_FAIL    = 'REPORT_DASHBOARD_DETAILS_FAIL';

export const REPORT_DASHBOARD_CREATE_REQUEST = 'REPORT_DASHBOARD_CREATE_REQUEST';
export const REPORT_DASHBOARD_CREATE_SUCCESS = 'REPORT_DASHBOARD_CREATE_SUCCESS';
export const REPORT_DASHBOARD_CREATE_FAIL    = 'REPORT_DASHBOARD_CREATE_FAIL';

export const REPORT_DASHBOARD_UPDATE_REQUEST = 'REPORT_DASHBOARD_UPDATE_REQUEST';
export const REPORT_DASHBOARD_UPDATE_SUCCESS = 'REPORT_DASHBOARD_UPDATE_SUCCESS';
export const REPORT_DASHBOARD_UPDATE_FAIL    = 'REPORT_DASHBOARD_UPDATE_FAIL';

export const REPORT_DASHBOARD_DELETE_REQUEST = 'REPORT_DASHBOARD_DELETE_REQUEST';
export const REPORT_DASHBOARD_DELETE_SUCCESS = 'REPORT_DASHBOARD_DELETE_SUCCESS';
export const REPORT_DASHBOARD_DELETE_FAIL    = 'REPORT_DASHBOARD_DELETE_FAIL';

export const REPORT_CATEGORY_LABEL_MAP_LIST_REQUEST = 'REPORT_CATEGORY_LABEL_MAP_LIST_REQUEST';
export const REPORT_CATEGORY_LABEL_MAP_LIST_SUCCESS = 'REPORT_CATEGORY_LABEL_MAP_LIST_SUCCESS';
export const REPORT_CATEGORY_LABEL_MAP_LIST_FAIL    = 'REPORT_CATEGORY_LABEL_MAP_LIST_FAIL';
